import { gql } from '@/__generated__';

const UPDATE_SMA_DEVICE_METRIC = gql(`#graphql 
  mutation UpdateSMAScheduledReportConfiguration($input: UpdateSMAScheduledReportConfigurationInput!) {
    updateSMAScheduledReportConfiguration(input: $input) {
      device {
        id
      }
      success
    }
  }
`);

export default UPDATE_SMA_DEVICE_METRIC;
